interface ActionButtonProps {
  children: React.ReactNode;
  imageUrl?: string;
  onClick?: () => void;
}

export const ActionButton = ({ children, imageUrl, onClick }: ActionButtonProps) => {
  return (
    <button className={`btn btn-secondary relative overflow-hidden ${imageUrl ? 'p-0' : ''}`} onClick={onClick}>
      {imageUrl ? (
        <img 
          src={imageUrl} 
          alt="Botón" 
          className="w-full h-full object-cover" 
        />
      ) : (
        children
      )}
    </button>
  );
};
